// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/backendFrontend/accessLabel.ts
import { AccessType, AccessTypeString } from '../../modules/access/types';

const ACCESS_LABEL_MAP: Record<AccessType, string> = {
  [AccessType.NONE]: 'Withdrawal access',
  [AccessType.PARTIAL]: 'Partial',
  [AccessType.READ]: 'Read',
  [AccessType.EDIT]: 'Edit',
  [AccessType.MANAGE]: 'Manage',
};

export const accessLabel = (v: AccessType | AccessTypeString) => {
  if (v === undefined || v === null) return 'Unknown';
  const num = typeof v === 'string' ? parseInt(v, 10) : v;
  return ACCESS_LABEL_MAP[num as AccessType] ?? 'Unknown';
};
